const BOTTOM_BLOCK = '.embroidery_bottom_block';
const bottomDom = {
  root() { return document.querySelector(BOTTOM_BLOCK); },
  get(id) { return document.getElementById(id); },
  qs(sel) {
    const root = this.root();
    return root ? root.querySelector(sel) : null;
  },
  qsa(sel) {
    const root = this.root();
    return root ? root.querySelectorAll(sel) : [];
  }
};

function isBottomEmbroideryFlow() {
  return document.querySelector('.embroidery-popup-container')?.getAttribute('data-emb-screen') === 'bottomemb';
}

/**
 * Shows or hides an element without writing inline styles.
 * @param {Element|null|undefined} el
 * @param {boolean} hidden
 */
function setBottomEmbHidden(el, hidden) {
  if (el) el.toggleAttribute('data-hidden', hidden);
}

/**
 * Switches the bottom counter between full width and shared with the error.
 * @param {Element|null|undefined} counter
 * @param {boolean} full
 */
function setBottomCounterFull(counter, full) {
  if (!counter) return;
  counter.toggleAttribute('data-full', full);
  counter.toggleAttribute('data-shared', !full);
}

const BOTTOM_MOBILE_QUERY = '(max-width: 1023px)';

// matchMedia never forces layout, unlike reading window.innerWidth
function isBottomMobileViewport() {
  return window.matchMedia(BOTTOM_MOBILE_QUERY).matches;
}

// Inline style is the source of truth (chnageTextBottomTransformation sets it) and no stylesheet sets text-transform
// on this input, so this avoids the getComputedStyle style recalc that used to run on every keystroke
function isBottomInputUpperCase(inputElement) {
  return inputElement.style.textTransform === 'uppercase' || inputElement.hasAttribute('data-uppercase');
}

function syncBottomHelperText() {
  const helper = bottomDom.qs('.thistextbottom_embroidery1');
  const error = bottomDom.qs('.error-message-bottom-main');
  if (!helper) return;

  const errorVisible = !!error && !error.hasAttribute('data-hidden');
  setBottomEmbHidden(helper, errorVisible);
}

function setupBottomCharCounter(inputId, countClass, errorClass = null) {
  try {
    const input = bottomDom.get(inputId);
    const scope = input?.closest('.engraving-form-container-bottom') || bottomDom.root();
    const counter = scope?.querySelector(`.${countClass}`);
    const error = errorClass ? scope?.querySelector(`.${errorClass}`) : null;
    const previewSvg = document.querySelector('.preview-text-overlay-svg');

    if (!input || !counter) return;
    const maxLength = Number(input.maxLength) > 0 ? Number(input.maxLength) : 22;
    counter.textContent = `${input.value.length}/${maxLength}`;

    if (input.dataset.bottomCharCounter === 'true') return;
    input.dataset.bottomCharCounter = 'true';

    input.addEventListener('input', function () {
      const len = this.value.length;
      counter.textContent = `${len}/${maxLength}`;

      if (error) {
        const hasText = len > 0;
        setBottomEmbHidden(error, hasText);
        setBottomCounterFull(counter, hasText);
        syncBottomHelperText();
      }

      if (previewSvg) {
        previewSvg.style.display = len > 0 ? 'none' : 'block';
      }
    }, { passive: true });
  } catch (error) {
    console.error(`Char counter init error for ${inputId}:`, error);
  }
}

function setupInputBottomSanitization(inputId) {
  const input = bottomDom.get(inputId);
  if (!input || input.dataset.bottomSanitized === 'true') return;
  input.dataset.bottomSanitized = 'true';

  const previewElement = document.querySelector('.preview-text-line1');

  function applyBottomCasing(text, inputElement) {
    if (isBottomInputUpperCase(inputElement)) return text.toUpperCase();
    return text
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  input.addEventListener('input', function () {
    let sanitized = this.value.replace(/[^a-zA-Z0-9 .]/g, '');
    sanitized = applyBottomCasing(sanitized, this);
    // Only write back when something changed: skips a redundant value write (and caret reset) per keystroke
    if (sanitized !== this.value) this.value = sanitized;
    if (previewElement) previewElement.textContent = sanitized;
  }, { passive: true });

  input.addEventListener('paste', function (e) {
    const pastedData = (e.clipboardData || window.clipboardData).getData('text');
    if (/[^a-zA-Z0-9 .]/.test(pastedData)) e.preventDefault();
  });
}

function getBottomVariantSku() {
  const bottomVariantInput = document.getElementById('bottom_product_variant_id');
  const selectedBottomVariantId = bottomVariantInput?.value;
  if (selectedBottomVariantId) {
    const inputSku = bottomVariantInput.getAttribute('data-sku');
    if (inputSku) return inputSku;

    const variantScript = document.querySelector('script[data-picker-variants="bottom"]');
    if (variantScript?.textContent) {
      try {
        const bottomVariants = JSON.parse(variantScript.textContent);
        const matchedBottom = Array.isArray(bottomVariants)
          ? bottomVariants.find((v) => v && String(v.id) === String(selectedBottomVariantId))
          : null;
        if (matchedBottom?.sku) return matchedBottom.sku;
      } catch (e) {
        console.error('Unable to resolve bottom SKU', e);
      }
    }
  }

  const embroideryBox = document.querySelector('.embroidery-box-rewamp');
  const garmentSku = embroideryBox?.getAttribute('data-selected-variant-sku');
  if (garmentSku) return garmentSku;

  return '';
}

function getEmbroideryVariantsBottom() {
  return window.embroideryProductBottom?.variants || [];
}

function findEmbroideryVariantByTitleBottom(title) {
  const normalized = String(title || '').trim().toLowerCase();
  return (
    getEmbroideryVariantsBottom().find(
      (variant) => String(variant?.title || '').trim().toLowerCase() === normalized
    ) || null
  );
}

function formatEmbroideryMoneyFromCentsBottom(cents) {
  const amount = Number(cents || 0) / 100;
  return `₹ ${amount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

function getEmbroiderySelectionDisplayLabelBottom(variantTitle) {
  const key = String(variantTitle || '').trim().toLowerCase();
  const labels = {
    'my name': 'Text',
    'both text': 'Bottom Text'
  };
  return labels[key] !== undefined ? labels[key] : String(variantTitle || '').trim();
}

function getCurrentEmbroiderySelectionBottom() {
  return { title: 'My Name' };
}

function syncTextColorLabelBottom() {
  const selectedColor = bottomDom.qs('.embformColorcontainer .text-color-option input[type="radio"]:checked');
  const colorLabel = bottomDom.qs('.text-color-selector #bottom-current-selected-color');
  if (!selectedColor || !colorLabel) return;
  colorLabel.textContent = selectedColor.value;
  const previewOverlay = document.querySelector('.preview-text-overlay');
  if (previewOverlay) previewOverlay.style.color = selectedColor.getAttribute('data-color');
}

function updateDescriptionBottom() {
  try {
    const desc = bottomDom.qs('.embroidery-popup-description');
    if (!desc) return;

    const selection = getCurrentEmbroiderySelectionBottom();
    if (!selection) {
      desc.innerHTML = '<p>Embroidery Selected</p>';
      desc.classList.remove('emb-msgupdated');
      return;
    }

    const variant = findEmbroideryVariantByTitleBottom(selection.title);
    if (!variant) {
      desc.innerHTML = '<p>Embroidery Selected</p>';
      desc.classList.remove('emb-msgupdated');
      return;
    }

    const compareAtPrice =
      Number(variant.compare_at_price) > Number(variant.price) ? Number(variant.compare_at_price) : null;
    const displayLabel = getEmbroiderySelectionDisplayLabelBottom(variant.title);
    desc.innerHTML = `
      <p>Embroidery Selected: <label class="EmbSelected_title">${displayLabel}</label></p>
      <span class="EmbSelected_price">
        ${formatEmbroideryMoneyFromCentsBottom(variant.price)}
        ${compareAtPrice ? `<span class="compare-at-price">${formatEmbroideryMoneyFromCentsBottom(compareAtPrice)}</span>` : ''}
      </span>
    `;
    desc.classList.add('emb-msgupdated');
  } catch (err) {
    console.error('updateDescriptionBottom error:', err);
  }
}

function applyFontToPreviewBottom(radio) {
  const previewText = document.querySelector('.preview-text-overlay');
  if (!previewText || !radio) return;

  const fontStyle = radio.getAttribute('data-fontstyle');
  previewText.style.fontFamily = fontStyle;
  if (fontStyle === 'Bookscript') {
    previewText.style.fontSize = isBottomMobileViewport() ? '18px' : '24px';
    previewText.style.lineHeight = '1';
  } else {
    previewText.style.fontSize = '';
  }
}

// One delegated listener per group instead of one per option. initBottomEmbroideryUi runs on every
// bottom entry, so the containers carry a flag to bind only once.
function setupBottomOptionPickers() {
  const colorContainer = bottomDom.qs('.embformColorcontainer');
  if (colorContainer && colorContainer.dataset.bottomColorBound !== 'true') {
    colorContainer.dataset.bottomColorBound = 'true';
    let colorSelectionId = 0;
    colorContainer.addEventListener('click', function (e) {
      const option = e.target.closest('.text-color-option');
      if (!option || !colorContainer.contains(option)) return;
      const radio = option.querySelector('input[type="radio"]');
      if (option.classList.contains('activess') && radio?.checked) return;

      // Instant highlight on the clicked swatch; the rest is non-urgent and runs after this paint
      option.classList.add('activess');
      const selectionId = ++colorSelectionId;
      setTimeout(() => {
        if (selectionId !== colorSelectionId) return;
        colorContainer.querySelectorAll('.text-color-option').forEach((opt) => {
          if (opt !== option) opt.classList.remove('activess');
        });
        if (!radio) return;
        radio.checked = true;
        syncTextColorLabelBottom();
      }, 0);
    });
  }

  const fontSelector = bottomDom.qs('.font-type-selector');
  if (fontSelector && fontSelector.dataset.bottomFontBound !== 'true') {
    fontSelector.dataset.bottomFontBound = 'true';
    fontSelector.addEventListener('click', function (e) {
      const option = e.target.closest('.font-type-option');
      if (!option || !fontSelector.contains(option)) return;
      option.classList.add('activess');
      fontSelector.querySelectorAll('.font-type-option').forEach((opt) => {
        if (opt !== option) opt.classList.remove('activess');
      });
      const radio = option.previousElementSibling;
      if (!radio) return;
      radio.checked = true;
      applyFontToPreviewBottom(radio);
    });
  }
}

function setBottomButtonLoading(button, isLoading) {
  if (!button) return;
  button.toggleAttribute('data-loading', isLoading);
  button.toggleAttribute('aria-busy', isLoading);
}

// Loader styles live in embroidery-popup-bundle.liquid (button.*.popup-contentsecondlvl_*[data-loading])
function setupPressLoaderBottom(buttonSelector) {
  const button = bottomDom.qs(`.button-group-bottom ${buttonSelector}`);
  if (!button || button.dataset.bottomPressLoader === 'true') return;
  button.dataset.bottomPressLoader = 'true';

  // pointerdown is its own task before click, so the loader paints before the button's work starts
  button.addEventListener('pointerdown', function () {
    if (!button.disabled) button.toggleAttribute('data-loading', true);
  });
  // Press dragged off or cancelled: no click follows, so drop the loader unless the work is running
  ['pointerleave', 'pointercancel'].forEach(function (type) {
    button.addEventListener(type, function (e) {
      // On touch, pointerleave fires right before click, so only treat it as cancel for a mouse
      if (e.type === 'pointerleave' && e.pointerType !== 'mouse') return;
      if (!button.hasAttribute('aria-busy')) button.removeAttribute('data-loading');
    });
  });
}

// Button entry points: show the loader, yield so it paints, then run the work in one frame.
// validateBottomEmbroidery / handleBottomEmbroideryAddedToCart stay synchronous for their other callers.
function runWithBottomButtonLoader(button, work) {
  if (button?.hasAttribute('aria-busy')) return;
  setBottomButtonLoading(button, true);
  setTimeout(function () {
    requestAnimationFrame(function () {
      try {
        work();
      } finally {
        setBottomButtonLoading(button, false);
      }
    });
  }, 0);
}

function resetBottomEmbroideryFromButton(button) {
  runWithBottomButtonLoader(button, function () { window.validateBottomEmbroidery(); });
}

function proceedBottomEmbroideryFromButton(button) {
  runWithBottomButtonLoader(button, handleBottomEmbroideryAddedToCart);
}

function initBottomEmbroideryUi() {
  try {
    setupBottomOptionPickers();
    setupPressLoaderBottom('.popup-contentsecondlvl_reset');
    setupPressLoaderBottom('.popup-contentsecondlvl_add');

    const selectedColor = bottomDom.qs('.text-color-option input[type="radio"]:checked');
    if (selectedColor) selectedColor.closest('.text-color-option')?.classList.add('activess');
    syncTextColorLabelBottom();

    const selectedFont = bottomDom.qs('.font-type-selector input[type="radio"]:checked');
    if (selectedFont?.nextElementSibling) selectedFont.nextElementSibling.classList.add('activess');

    setupBottomCharCounter('bottom_inputline1', 'char-count-bottom-main', 'error-message-bottom-main');
    setupInputBottomSanitization('bottom_inputline1');
    syncBottomHelperText();
    updateDescriptionBottom();
  } catch (err) {
    console.error('initBottomEmbroideryUi error:', err);
  }
}

function initBottomEmbroideryEntry() {
  const textSection = bottomDom.qs('.engraving-form-container-bottom');
  const textPreview = document.querySelector('.preview-text-overlay');
  const previewImage = document.querySelector('.preview-image-wrapper');
  if (textSection) textSection.style.display = 'block';
  if (textPreview) textPreview.style.display = 'block';
  if (previewImage) previewImage.style.display = 'none';

  initBottomEmbroideryUi();
  updateDescriptionBottom();
  syncTextColorLabelBottom();
}

function scrollToBottomElement(el) {
  if (el && typeof el.scrollIntoView === 'function') {
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

function handleBottomEmbroideryAddedToCart() {
  try {
    const line1 = bottomDom.get('bottom_inputline1');
    const isTextValid = !!line1?.value?.trim();

    if (!isTextValid) {
      const container = line1?.closest('.engraving-form-container-bottom');
      const error = container?.querySelector('.error-message-bottom-main');
      const counter = container?.querySelector('.char-count-bottom-main');
      setBottomEmbHidden(error, false);
      setBottomCounterFull(counter, false);
      syncBottomHelperText();
      if (error) scrollToBottomElement(error);
      return;
    }

    const embroideryInput = bottomDom.qs('.embroidery-popup-input.emb-padding');
    if (embroideryInput) embroideryInput.style.display = 'none';

    const finalEmbroideryInfo = bottomDom.root()?.querySelector('.finalEmbroidery_info');
    if (finalEmbroideryInfo) finalEmbroideryInfo.style.display = 'block';
  } catch (error) {
    console.error('Error in handleBottomEmbroideryAddedToCart:', error);
  }
}

function gobackBottomEmbroidery() {
  try {
    const finalInfo = bottomDom.root()?.querySelector('.finalEmbroidery_info');
    if (finalInfo) finalInfo.style.display = 'none';
    const popupInput = bottomDom.qs('.embroidery-popup-input.emb-padding');
    if (popupInput) popupInput.style.display = 'block';
  } catch (error) {
    console.error('Error in gobackBottomEmbroidery:', error);
  }
}

window.validateBottomEmbroidery = function () {
  const line1Input = bottomDom.get('bottom_inputline1');
  const previewSvg = document.querySelector('.preview-text-overlay-svg');
  const previewLine1 = document.querySelector('.preview-text-line1');

  if (line1Input) line1Input.value = '';
  if (previewSvg) previewSvg.style.display = 'block';
  if (previewLine1) previewLine1.textContent = '';

  const counter = bottomDom.qs('.char-count-bottom-main');
  const error = bottomDom.qs('.error-message-bottom-main');
  if (counter) {
    counter.textContent = '0/22';
    setBottomCounterFull(counter, true);
  }
  setBottomEmbHidden(error, true);
  syncBottomHelperText();
  updateDescriptionBottom();
};

function applyBottomEmbroidery(section, text) {
  const textSection = section.querySelector('.list_row_only_Text_bottom');
  if (!textSection) return;

  const textColor = bottomDom.qs('.text-color-options input:checked')?.value || '';
  const fontStyle = bottomDom.qs('.font-type-selector input:checked')?.value || '';

  textSection.querySelector('.selected-Name-centered .emb_first_Maind').textContent = text;
  const line2Node = textSection.querySelector('.selected-Name-centered .emb_sec_opt');
  if (line2Node) line2Node.textContent = '';
  const textEmbNode = textSection.querySelector('span.property_line__textEmb.property_line__textEmbfirst');
  if (textEmbNode) textEmbNode.textContent = text;

  const colorNode = textSection.querySelector('span.property_line.property_line_colorValue');
  if (colorNode) colorNode.textContent = textColor;
  const fontNode = textSection.querySelector('span.property_line_FontStyle');
  if (fontNode) fontNode.textContent = fontStyle;

  textSection.style.display = 'grid';
}

function handleBottomEmbroideryConfirmation() {
  const bottomText = bottomDom.get('bottom_inputline1')?.value?.trim() || '';
  if (!bottomText) return;

  const bottomEmbroiderySku = getBottomVariantSku();
  const embroiderySection = document.querySelector('.embroidery-box-rewamp');
  if (!embroiderySection) return;

  const embFirstscreenOptions = document.querySelectorAll("input[name='emb_firstscreen_option']");
  embFirstscreenOptions.forEach((radio) => {
    if (radio.checked) {
      const embrtype = radio.value;
      const editLabel = embroiderySection.querySelector('.added_list label[data-embrtype]');
      if (editLabel) {
        editLabel.removeAttribute('data-embrtype');
        editLabel.setAttribute('data-embrtype', embrtype);
      }
    }
  });

  embroiderySection.querySelector('input.embroidery_filled').checked = true;
  embroiderySection.querySelector('.popupbtnembroidery').checked = false;
  embroiderySection.querySelector('.added_list').style.display = 'block';
  embroiderySection.querySelector('.embMaiDiv').style.display = 'none';
  embroiderySection.querySelector('.btn_pack').style.display = 'none';
  embroiderySection.querySelector('.list_row_only_Text').style.display = 'none';
  embroiderySection.querySelector('.list_row_only_Image').style.display = 'none';
  embroiderySection.querySelector('.list_row_both').style.display = 'none';
  const bottomTextRow = embroiderySection.querySelector('.list_row_only_Text_bottom');
  if (bottomTextRow) bottomTextRow.style.display = 'none';

  applyBottomEmbroidery(embroiderySection, bottomText);

  const selectedVariant = findEmbroideryVariantByTitleBottom('Bottom');
  if (selectedVariant) {
    embroiderySection.setAttribute('data-selected-variant-id', selectedVariant.id);
    const displayTitle = getEmbroiderySelectionDisplayLabelBottom(selectedVariant.title);
    embroiderySection.querySelectorAll('.property_line__textEmbWrapper h4').forEach((titleEl) => {
      titleEl.textContent = displayTitle;
    });
    const priceElement = embroiderySection.querySelector('.box_price');
    if (priceElement) priceElement.textContent = formatEmbroideryMoneyFromCentsBottom(selectedVariant.price);
  }

  embroiderySection.querySelectorAll('.property_line_BottomText').forEach((row) => {
    const valueNode = row.querySelector('.property_line_BottomTextValue');
    row.style.display = 'block';
    if (valueNode) valueNode.textContent = bottomText;
  });

  embroiderySection.setAttribute('data-bottom-embroidery-enabled', 'true');
  embroiderySection.setAttribute('data-bottom-embroidery-text', bottomText);
  if (bottomEmbroiderySku) {
    embroiderySection.setAttribute('data-bottom-embroidery-sku', bottomEmbroiderySku);
  } else {
    embroiderySection.removeAttribute('data-bottom-embroidery-sku');
  }

  if (typeof closeEmbroideryPopup === 'function') closeEmbroideryPopup();
  document.querySelector('.popupbtnembroidery').checked = true;
  if (typeof checkAllSelections === 'function') {
    checkAllSelections();
  }
}

window.EmbroideryDeleteBottom = function () {
  try {
    const embroideryBox = document.querySelector('.embroidery-box-rewamp');
    if (!embroideryBox) return;

    embroideryBox.querySelector('input.embroidery_filled').checked = false;
    embroideryBox.querySelector('.popupbtnembroidery').checked = false;
    embroideryBox.querySelector('.added_list').style.display = 'none';
    embroideryBox.querySelector('.embMaiDiv').style.display = 'block';
    embroideryBox.querySelector('.btn_pack').style.display = 'flex';
    embroideryBox.querySelector('.list_row_only_Text').style.display = 'none';
    embroideryBox.querySelector('.list_row_only_Image').style.display = 'none';
    embroideryBox.querySelector('.list_row_both').style.display = 'none';
    const bottomTextRow = embroideryBox.querySelector('.list_row_only_Text_bottom');
    if (bottomTextRow) {
      bottomTextRow.style.display = 'none';
      const bottomNameSection = bottomTextRow.querySelector('.selected-Name-centered');
      if (bottomNameSection) {
        bottomNameSection.querySelector('.emb_first_Maind').textContent = '';
        const line2 = bottomNameSection.querySelector('.emb_sec_opt');
        if (line2) line2.textContent = '';
      }
      const bottomTextEmb = bottomTextRow.querySelector('span.property_line__textEmb.property_line__textEmbfirst');
      if (bottomTextEmb) bottomTextEmb.textContent = '';
    }

    const textSection = embroideryBox.querySelector('.list_row_only_Text .selected-Name-centered');
    if (textSection) {
      textSection.querySelector('.emb_first_Maind').textContent = '';
      const line2 = textSection.querySelector('.emb_sec_opt');
      if (line2) line2.textContent = '';
    }
    const mainText = embroideryBox.querySelector('span.property_line__textEmb.property_line__textEmbfirst');
    if (mainText) mainText.textContent = '';

    embroideryBox.querySelectorAll('.property_line_BottomText').forEach((row) => {
      row.style.display = 'none';
    });
    embroideryBox.querySelectorAll('.property_line_BottomTextValue').forEach((valueNode) => {
      valueNode.textContent = '';
    });

    embroideryBox.removeAttribute('data-bottom-embroidery-enabled');
    embroideryBox.removeAttribute('data-bottom-embroidery-text');
    embroideryBox.removeAttribute('data-bottom-embroidery-sku');

    // Target the Edit button that carries data-embrtype, not the hidden .edit_box before it:
    // adding the attribute there makes confirm handlers save the type to the wrong label
    const editLabel = embroideryBox.querySelector('.added_list label.edit_box[data-embrtype]');
    if (editLabel) editLabel.setAttribute('data-embrtype', '');

    validateBottomEmbroidery();
    gobackBottomEmbroidery();
  } catch (error) {
    console.error('Error in EmbroideryDeleteBottom:', error.message);
  }
};

function chnageTextBottomTransformation(trigger) {
  const container = trigger.closest('.engraving-form-container_transformation');
  const input = container?.querySelector('input');
  if (!input) return;

  const isUpperCase = input.style.textTransform === 'uppercase';
  if (isUpperCase) {
    input.style.textTransform = 'capitalize';
    input.value = input.value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
    trigger.querySelector('.text_trasformation_name_captaln').style.display = 'none';
    trigger.querySelector('.text_trasformation_name_small').style.display = 'block';
    trigger.classList.remove('background_text');
  } else {
    input.style.textTransform = 'uppercase';
    input.value = input.value.toUpperCase();
    trigger.querySelector('.text_trasformation_name_captaln').style.display = 'block';
    trigger.querySelector('.text_trasformation_name_small').style.display = 'none';
    trigger.classList.add('background_text');
  }

  const previewLine1 = document.querySelector('.preview-text-line1');
  if (previewLine1) previewLine1.textContent = input.value;
}

function getSavedEmbrTypeBottom() {
  return document.querySelector(
    '.embroidery-box-rewamp .added_list label[data-embrtype], .embroidery-box .added_list label[data-embrtype]'
  )?.getAttribute('data-embrtype');
}

function restoreBottomEmbroideryFromAdded() {
  try {
    const box = document.querySelector('.embroidery-box-rewamp');
    if (!box) return;

    const textRow = box.querySelector('.list_row_only_Text');
    if (!textRow || textRow.style.display === 'none') return;

    const line1 = textRow.querySelector('.emb_first_Maind')?.textContent?.trim() || '';
    const color = textRow.querySelector('.property_line_colorValue')?.textContent?.trim() || '';
    const font = textRow.querySelector('.property_line_FontStyle')?.textContent?.trim() || '';
    const line1Input = bottomDom.get('bottom_inputline1');
    const previewLine1 = document.querySelector('.preview-text-line1');
    const previewSvg = document.querySelector('.preview-text-overlay-svg');

    if (line1Input) {
      line1Input.value = line1;
      line1Input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    if (previewLine1) previewLine1.textContent = line1;
    if (previewSvg) previewSvg.style.display = line1 ? 'none' : 'block';

    if (color) {
      const normalized = color.toLowerCase();
      bottomDom.qsa('.text-color-option input[type="radio"]').forEach((radio) => {
        if (String(radio.value).trim().toLowerCase() !== normalized) return;
        radio.checked = true;
        bottomDom.qsa('.text-color-option').forEach((opt) => opt.classList.remove('activess'));
        radio.closest('.text-color-option')?.classList.add('activess');
        syncTextColorLabelBottom();
      });
    }

    if (font) {
      const normalized = font.toLowerCase();
      bottomDom.qsa('.font-type-selector input[type="radio"]').forEach((radio) => {
        if (String(radio.value).trim().toLowerCase() !== normalized) return;
        radio.checked = true;
        bottomDom.qsa('.font-type-option').forEach((opt) => opt.classList.remove('activess'));
        radio.nextElementSibling?.classList.add('activess');
      });
    }

    syncTextColorLabelBottom();
    updateDescriptionBottom();
  } catch (error) {
    console.error('restoreBottomEmbroideryFromAdded error:', error);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBottomEmbroideryUi, { once: true });
} else {
  initBottomEmbroideryUi();
}

(function installBottomEmbroideryRoutes() {
  const prevHandlers = {
    confirm: window.handleEmbroideryConfirmation,
    goback: window.gobackEmbroidery,
    delete: window.EmbroideryDelete,
    edited: window.EmbroideryEdited
  };

  window.handleBottomEmbroideryConfirmation = handleBottomEmbroideryConfirmation;
  window.handleBottomEmbroideryAddedToCart = handleBottomEmbroideryAddedToCart;
  window.resetBottomEmbroideryFromButton = resetBottomEmbroideryFromButton;
  window.proceedBottomEmbroideryFromButton = proceedBottomEmbroideryFromButton;
  window.gobackBottomEmbroidery = gobackBottomEmbroidery;
  window.initBottomEmbroideryEntry = initBottomEmbroideryEntry;
  window.chnageTextBottomTransformation = chnageTextBottomTransformation;
  window.restoreBottomEmbroideryFromAdded = restoreBottomEmbroideryFromAdded;

  window.handleEmbroideryConfirmation = function () {
    if (isBottomEmbroideryFlow()) {
      handleBottomEmbroideryConfirmation();
    } else if (prevHandlers.confirm) {
      prevHandlers.confirm();
    }
    if (typeof checkAllSelections === 'function') {
      checkAllSelections();
    }
  };

  window.gobackEmbroidery = function (embrtype) {
    if (isBottomEmbroideryFlow()) return gobackBottomEmbroidery();
    if (prevHandlers.goback) return prevHandlers.goback(embrtype);
  };

  window.EmbroideryDelete = function () {
    const embrtype = getSavedEmbrTypeBottom();
    if (embrtype === 'bottomemb' || isBottomEmbroideryFlow()) return window.EmbroideryDeleteBottom();
    if (prevHandlers.delete) return prevHandlers.delete();
  };

  window.EmbroideryEdited = function (editLabel) {
    if (typeof window.openEmbroideryEditPicker === 'function') {
      return window.openEmbroideryEditPicker(editLabel);
    }
    const embrtype = editLabel?.getAttribute?.('data-embrtype') || getSavedEmbrTypeBottom();
    if (embrtype === 'topemb' && window.handleTopEmbroideryEdited) {
      return window.handleTopEmbroideryEdited(editLabel);
    }
    if (prevHandlers.edited) return prevHandlers.edited(editLabel);
  };
})();
